// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const lillipup: PokeData = {
  "id": 506,
  "name": "lillipup",
  "height": 4,
  "weight": 41,
  "base_experience": 55,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "tackle",
    "take-down",
    "leer",
    "bite",
    "roar",
    "reversal",
    "crunch",
    "helping-hand",
    "odor-sleuth",
    "last-resort",
    "giga-impact",
    "retaliate",
    "work-up",
    "play-rough",
    "baby-doll-eyes"
  ],
  "moves": [
    "tackle",
    "leer",
    "bite",
    "crunch",
    "play-rough",
    "body-slam",
    "growl",
    "purification",
    "protect",
    "quick-attack",
    "scratch",
    "refresh",
    "splash"
  ],
  "evolution_chain": {
    "id": 260,
    "item": null,
    "species": [
      {
        "name": "lillipup",
        "order": 507,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "herdier",
        "order": 508,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 506,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 16,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "stoutland",
        "order": 509,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 507,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 32,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 45,
    "speed": 55,
    "ability_power": 60
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
